
  
$(document).ready(function() {
  window.maps = [];
  window.filteredStores = window.stores.slice(); // Clone initial stores

  let center_location = 'Unit 2, Medlock Court, The City Works, Welcomb St, Openshaw, Manchester M11 2NB, United Kingdom';
  // async function Geolocate(address) {
  //   if (!address) return;
  //   var geocoder = new google.maps.Geocoder();
  //   let results = await geocoder.geocode({ address: address });

  //   return results;
  // }

  async function Geolocate(address) {
    if (!address) return null;

    try {
      const geocoder = new google.maps.Geocoder();
      const response = await geocoder.geocode({ address: address });

      if (!response.results || !response.results.length) {
        console.warn("No results for:", address);
        return null;
      }

      return response;
    } catch (error) {
      console.error("Geocode failed:", error);
      return null;
    }
  }
  

  function initGoogleMaps() {
    if (!window.stores.length) return;
    Geolocate(center_location).then(result => {
      if (!result) {
        console.error("Center location not found");
        return;
      }

      const location = result.results[0].geometry.location;
      $('.stockists-map').each(function() {
        const map = new google.maps.Map(this, {
          zoom: 5,
          center: { lat: location.lat(), lng: location.lng() },
          styles: [
            // Remove points of interest
            {
              featureType: "poi",
              stylers: [{ visibility: "off" }]
            },
            // Remove transit icons like subway stations
            {
              featureType: "transit",
              stylers: [{ visibility: "off" }]
            },
            // Lighten all roads
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#e0e0e0" }] // lighter than #cccccc
            },
            // Simplify road labels
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#666666" }]
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ffffff" }]
            },
            // Highway lines slightly darker
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#c7c7c7" }]
            },
            // Highway shield text (number) – white
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ffffff" }]
            },
            // Highway shield box – grey
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#999999" }]
            },
            // Water styling (blue)
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#46bcec" }]
            },
            // Land background light gray
            {
              featureType: "landscape",
              elementType: "geometry.fill",
              stylers: [{ color: "#f2f2f2" }]
            },
            // Hide business labels
            {
              featureType: "poi.business",
              stylers: [{ visibility: "off" }]
            },
            // Remove administrative borders
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ visibility: "off" }]
            }
          ]
        });

        addMarkersToMap(map);
        window.maps.push(map);
      });
    });
  }

   function addMarkersToMap(map) {
    const geoPromises = window.stores.map(store => Geolocate(store.map_address));
  
    // Create a variable to track the currently open InfoWindow
    let currentOpenInfoWindow = null;
  
    Promise.all(geoPromises).then(results => {
      results.forEach((result, index) => {
        const store = window.stores[index];
        if (!result || !result.results.length) {
          console.warn("Skipping store (no location found):", store.map_address);
          return;
        }
        const loc = result.results[0].geometry.location;
        const marker = new google.maps.Marker({
          position: { lat: loc.lat(), lng: loc.lng() },
          map: map,
          title: store.title,
          icon: {
            url: '//ursastraps.com/cdn/shop/t/35/assets/icon-map-circle.svg?v=155198879382460739161787006274',
            scaledSize: new google.maps.Size(40, 40), // width, height in pixels
            // optional anchor if needed:
            // anchor: new google.maps.Point(20, 20)
          }
        });
          
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(store.description, 'text/html');
        const parsedHTML = parsedDoc.body.firstElementChild?.innerHTML || '';
  
        const infowindow = new google.maps.InfoWindow({
          content: `
            <div class="map-stockist-wrap">
              <div class="stockist-title">${store.title.toUpperCase()}</div>
              <div class="stockist-address">
                <div>${parsedHTML}</div>
              </div>
              <div class="stockist-link">
                <a target="_blank" href="${store.url}">VIEW WEBSITE</a>
              </div>
            </div>
          `,
          disableAutoPan: false
        });
  
        store.marker = marker;
        store.infowindow = infowindow;
  
        marker.addListener('click', function () {
          // Close the currently open InfoWindow if any
          if (currentOpenInfoWindow && currentOpenInfoWindow !== infowindow) {
            currentOpenInfoWindow.close();
          }
  
          // Open the new InfoWindow
          infowindow.open(map, marker);
  
          // Set the new InfoWindow as currently open
          currentOpenInfoWindow = infowindow;
  
          zoomToStore(store);
        });
      });
    });
  }


  function zoomToStore(store) {
    window.maps.forEach(map => {
      map.setZoom(10);
      map.panTo(store.marker.getPosition());
      store.infowindow.open(map, store.marker);

      //animation when location is clicked
      store.marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(function(){ store.marker.setAnimation(null); }, 1500);
    });
  }

  $(document).on('click', '.list-stores .view-map-btn,.list-stores .stockist-title', function() {
    const index = parseInt($(this).data('index'));
    const store = window.stores[index];
        $("html, body").animate({
          scrollTop: $('.map-container').offset().top - (window.screen.width > 749 ? 100 : 50)
        }, 1);
    if (store) zoomToStore(store);
  });

  // Load Google Maps API
  function loadGoogleMapsAPI() {
    const apiKey = 'AIzaSyBUVqBLID1sjaNNLWedr1N9dsmNz0t2RUg';
    const script = document.createElement('script');
    script.onload = initGoogleMaps;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    document.head.appendChild(script);
  }

  if (window.stores && window.stores.length) {
    loadGoogleMapsAPI();
    // renderFilteredStores(); // Initial render
  }
  $('body').on('change', 'select[data-filter="map-filter"]', function () {
    const selectedGroup = $(this).val();
  
    $('.stockist-group').each(function () {
      const group = $(this).data('group');
      if (selectedGroup === '' || group === selectedGroup) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  const $container = $('.stockist-container');
  let originalOrder = $container.find('.stockist-group').toArray();
  
  $('body').on('change', 'select[name="map_sorting"]', function () {
    let val = $(this).val();
    let $groups = $container.find('.stockist-group');
  
    let sorted = [...(val ? $groups : originalOrder)];
  
    if (val === 'ascending') {
      sorted.sort((a, b) => $(a).data('group').localeCompare($(b).data('group')));
    } else if (val === 'descending') {
      sorted.sort((a, b) => $(b).data('group').localeCompare($(a).data('group')));
    }
  
    $container.append(sorted);
  });
    
});


